import { render, staticRenderFns } from "./DataEquipmentRegions.vue?vue&type=template&id=27980024"
import script from "./DataEquipmentRegions.vue?vue&type=script&lang=js"
export * from "./DataEquipmentRegions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports